import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA service worker 캐시가 새 빌드 적용을 막아온 사례가 있어 비활성화
// (등록되어 있던 기존 SW 가 있으면 unregister 해서 다음 로드부터 fresh 빌드 사용)
serviceWorkerRegistration.unregister();
